import React, { useMemo } from 'react';
import { formatTableDate } from '../../../utils/intelAxisTableUtils';
import CompanyBrandCell from '../../../components/CompanyBrandCell';
import NewsArticleIframe from './NewsArticleIframe';

function sourceHostname(url) {
  try {
    return new URL(url).hostname.replace(/^www\./i, '');
  } catch {
    return '';
  }
}

export default function NewsArticleView({ article }) {
  const embedUrl = article?.landingPageUrl || null;
  const host = useMemo(() => sourceHostname(embedUrl), [embedUrl]);
  const newsDate = formatTableDate(article?.dateOfNews);

  return (
    <div className="news-article-view">
      <aside className="news-article-view__aside report-card">
        <p className="news-article-view__aside-label">Company</p>
        <div className="news-article-view__aside-company">
          <CompanyBrandCell companyName={article?.company} />
        </div>
        <p className="news-article-view__aside-label">Published</p>
        <p className="news-article-view__aside-value">{newsDate}</p>
        {host ? (
          <>
            <p className="news-article-view__aside-label">Source</p>
            <p className="news-article-view__aside-value">{host}</p>
          </>
        ) : null}
        <p className="news-article-view__aside-label">Summary</p>
        <p className="news-article-view__aside-summary">
          {article?.introText || 'No summary available.'}
        </p>
      </aside>
      <div className="news-article-view__main">
        <NewsArticleIframe
          url={embedUrl}
          title={article?.headline || 'News article'}
        />
      </div>
    </div>
  );
}
